/* JS AI Search part 4: combinations, sold-out alternatives, similar products, live check. Loaded in order with the other js-ai-*.js files (see snippets/js-ai-search-boot.liquid).
   Overview and switches: see the header of js-ai-1-nlp.js. */
(function (root) {
  'use strict';
  var X = root.JSAIX = root.JSAIX || {};
  var Engine = X.Engine, newReply = X.newReply, toItem = X.toItem, allIn = X.allIn, r4 = X.r4, cmpStr = X.cmpStr, stem = X.stem;
  Engine.prototype._categoryDocs = function (words, budget) {
    var self = this;
    var stems = words.map(function (w) { return self._correct(stem(w)); });
    var concepts = this._concepts(stems);
    if (!concepts.length) return { scored: [], typeHit: false };
    var typeHit = false, scored = [], heads = {};
    this._match(concepts).forEach(function (r) {
      var doc = r.doc;
      if (r.matched !== concepts.length || !doc.p.available) return;
      concepts.forEach(function (c) {
        c.alts.forEach(function (a) {
          if (allIn(doc.ptypeSet, a.alt)) {
            typeHit = true;
            if (doc.ptype.length && a.alt[a.alt.length - 1] === doc.ptype[doc.ptype.length - 1]) heads[doc.p.id] = true;
          }
        });
      });
      if (budget.max !== null && doc.p.min > budget.max) return;
      scored.push({ doc: doc, score: r.score });
    });
    if (Object.keys(heads).length && scored.some(function (s) { return heads[s.doc.p.id]; })) {
      scored = scored.filter(function (s) { return heads[s.doc.p.id]; });
    }
    scored.sort(function (x, y) { return (-r4(x.score)) - (-r4(y.score)) || x.doc.p.min - y.doc.p.min || cmpStr(x.doc.p.title.toLowerCase(), y.doc.p.title.toLowerCase()); });
    return { scored: scored, typeHit: typeHit };
  };

  Engine.prototype._bundles = function (reply, parts, budget, limit) {
    parts = parts.slice(0, 3);
    var pools = [];
    for (var i = 0; i < parts.length; i++) {
      var c = this._categoryDocs(parts[i], budget);
      if (!c.typeHit || !c.scored.length) return;
      pools.push(c.scored.slice(0, 12));
    }
    var ranked = [];
    (function walk(idx, combo) {
      if (idx === pools.length) {
        var ids = {}, n = 0;
        combo.forEach(function (e) { if (!ids[e.doc.p.id]) { ids[e.doc.p.id] = true; n++; } });
        if (n !== combo.length) return;
        var total = combo.reduce(function (s, e) { return s + e.doc.p.min; }, 0);
        if (total > budget.max) return;
        var score = combo.reduce(function (s, e) { return s + r4(e.score); }, 0);
        ranked.push({ score: -score, total: -total, titles: combo.map(function (e) { return e.doc.p.title.toLowerCase(); }), combo: combo.slice(), sum: total });
        return;
      }
      pools[idx].forEach(function (e) { combo.push(e); walk(idx + 1, combo); combo.pop(); });
    })(0, []);
    ranked.sort(function (x, y) {
      if (x.score !== y.score) return x.score - y.score;
      if (x.total !== y.total) return x.total - y.total;
      for (var i = 0; i < x.titles.length; i++) { var c = cmpStr(x.titles[i], y.titles[i]); if (c) return c; }
      return 0;
    });
    var used = {};
    for (var r = 0; r < ranked.length; r++) {
      var combo = ranked[r].combo, clash = combo.some(function (e) { return used[e.doc.p.id]; });
      if (clash) continue;
      combo.forEach(function (e) { used[e.doc.p.id] = true; });
      reply.bundles.push({ items: combo.map(function (e) { return toItem(e.doc.p, 'bundle'); }), total: ranked[r].sum });
      if (reply.bundles.length >= Math.min(3, Math.max(1, limit))) break;
    }
  };

  Engine.prototype._alternatives = function (reply, soldDocs, budget, limit) {
    var self = this, types = {}, tokens = {}, vendors = {}, prices = [];
    soldDocs.forEach(function (d) {
      if (d.p.type) types[d.p.type] = (types[d.p.type] || 0) + 1;
      for (var t in d.titleSet) tokens[t] = true;
      for (var v in d.vendorSet) vendors[v] = true;
      prices.push(d.p.min);
    });
    var maxc = 0; for (var ty in types) maxc = Math.max(maxc, types[ty]);
    var top = {}, hasTop = false;
    for (var ty2 in types) if (types[ty2] === maxc) { top[ty2] = true; hasTop = true; }
    for (var sw in this.stopStems) delete tokens[sw];
    var target = prices.reduce(function (a, b) { return a + b; }, 0) / (prices.length || 1);
    var soldIds = {}; soldDocs.forEach(function (d) { soldIds[d.p.id] = true; });
    var ranked = [];
    this.docs.forEach(function (doc) {
      var p = doc.p;
      if (!p.available || soldIds[p.id]) return;
      if (budget.max !== null && p.min > budget.max) return;
      if (budget.min !== null && p.max < budget.min) return;
      if (hasTop && !top[p.type]) return;
      var overlap = 0; for (var t in doc.titleSet) if (tokens[t]) overlap++;
      if (!hasTop && overlap === 0) return;
      var vk = Object.keys(doc.vendorSet), sameVendor = vk.length && vk.every(function (x) { return vendors[x]; }) ? 1 : 0;
      ranked.push({ k0: -(overlap + 2 * sameVendor), k1: Math.abs(p.min - target), title: p.title.toLowerCase(), id: p.id, p: p });
    });
    ranked.sort(function (a, b) { return a.k0 - b.k0 || a.k1 - b.k1 || cmpStr(a.title, b.title) || cmpStr(a.id, b.id); });
    ranked.slice(0, Math.max(0, Math.min(limit, 4))).forEach(function (r) { reply.alternatives.push(toItem(r.p, 'alternative')); });
  };

  Engine.prototype.similarTo = function (ref, limit) {
    limit = limit === undefined ? 5 : limit;
    var src = this.byHandle[String(ref).trim()], reply = newReply('similar to ' + String(ref).slice(0, 80));
    if (!src) return reply;
    var stop = this.stopStems, words = {}, tags = {};
    for (var w in src.titleSet) if (!stop[w]) words[w] = true;
    src.tagSets.forEach(function (s) { for (var t in s) if (!stop[t]) tags[t] = true; });
    var ranked = [];
    this.docs.forEach(function (doc) {
      var p = doc.p;
      if (p.id === src.p.id || !p.available) return;
      var sameType = !!src.p.type && p.type === src.p.type;
      var score = 3.0 * (sameType ? 1 : 0), shared = 0, tagShared = {};
      for (var w2 in doc.titleSet) if (!stop[w2] && words[w2]) shared++;
      score += 1.0 * shared;
      doc.tagSets.forEach(function (s) { for (var t in s) tagShared[t] = true; });
      var tg = 0; for (var t2 in tagShared) if (tags[t2]) tg++;
      if (doc.tagSets.length) score += 0.5 * tg;
      var dv = Object.keys(doc.vendorSet), sv = Object.keys(src.vendorSet);
      if (dv.length && dv.length === sv.length && dv.every(function (x) { return src.vendorSet[x]; })) score += 1.5;
      if (score < 3.0) return;
      ranked.push({ k0: -score, k1: Math.abs(p.min - src.p.min), title: p.title.toLowerCase(), id: p.id, p: p });
    });
    ranked.sort(function (a, b) { return a.k0 - b.k0 || a.k1 - b.k1 || cmpStr(a.title, b.title) || cmpStr(a.id, b.id); });
    ranked.slice(0, Math.max(0, limit)).forEach(function (r) { reply.items.push(toItem(r.p, 'similar')); });
    return reply;
  };

  Engine.prototype._browse = function (reply, budget, limit) {
    var groups = {}, self = this;
    this.docs.forEach(function (doc) {
      var p = doc.p;
      if (!p.available || self.K.browseExcluded[p.type]) return;
      if (budget.max !== null && p.min > budget.max) return;
      if (budget.min !== null && p.max < budget.min) return;
      var key = p.type || 'Other';
      (groups[key] = groups[key] || []).push(p);
    });
    var ranked = Object.keys(groups).map(function (k) { return [k, groups[k]]; });
    ranked.sort(function (a, b) { return b[1].length - a[1].length || cmpStr(a[0].toLowerCase(), b[0].toLowerCase()); });
    ranked.slice(0, Math.max(0, limit)).forEach(function (g) {
      g[1].sort(function (a, b) { return b.min - a.min || cmpStr(a.title.toLowerCase(), b.title.toLowerCase()) || cmpStr(a.id, b.id); });
      reply.items.push(toItem(g[1][0], 'budget'));
    });
    reply.kind = 'budget';
  };

  // ------------------------------------------------------------------ live verification
  function livePrice(v) { return Math.round(Number(v.price)); }  // /products/<handle>.js prices are in minor units (pence)

  /** Compare an indexed product with the live storefront product. Returns an updated item or null. */
  function applyLive(item, live, budget) {
    var vs = (live.variants || []).filter(function (v) { return v.available; });
    if (!vs.length) return null;                                   // sold out right now
    var prices = vs.map(livePrice);
    var min = Math.min.apply(null, prices), max = Math.max.apply(null, prices);
    if (budget) {
      if (budget.max !== null && budget.max !== undefined && min > budget.max) return null;
      if (budget.min !== null && budget.min !== undefined && max < budget.min) return null;
    }
    var out = {}; for (var k in item) out[k] = item[k];
    out.priceMin = min; out.priceMax = max; out.verified = true; out.variantCount = (live.variants || []).length;
    out.variants = vs.map(function (v) { return { id: String(v.id), title: v.title, price: livePrice(v), available: true }; });
    if (live.featured_image && !out.image) out.image = live.featured_image;
    return out;
  }

  X.applyLive = applyLive;
  root.JSAICore = { Engine: Engine, parseBudget: X.parseBudget, isConversational: X.isConversational, wantsSimilar: X.wantsSimilar,
    tokenize: X.tokenize, stem: X.stem, applyLive: applyLive, cleanText: X.cleanText };
})(window);